<template><p /></template>
<script>
/* eslint-disable global-require */

import { getHomeRouteForLoggedInUser } from '@/auth/utils'

export default {
  beforeCreate() {
    const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
      appLoading.style.display = ''
    }
    const query = { ...this.$route.query }
    this.$router.replace({ query: null })
    if (query && Object.keys(query).includes('code')) {
      this.$store.dispatch('oneID/confirm', query).then(() => {
        this.$router.go(0)
      }).catch(err => {
        this.$errorSwal(this, err)
      })
    } else {
      this.$router.replace(getHomeRouteForLoggedInUser())
    }
  },
}
</script>
